import { Route, Routes, Navigate } from "react-router-dom";
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import Crm from "../pages/Crm";
import ResetPassword from "../pages/ResetPassword";
import ProtectedRoute from "./ProtectedRoutes";
import PublicRoute from "./PublicRoutes";
import Error from "../pages/Error";
import Staff from "../pages/Staff";
import Time from "../pages/Time";
import Invoices from "../pages/Invoices";
import Payment from "../pages/Payment";
import Production from "../pages/Production";
import ProductionDetail from "../components/production/ProductionDetail";
import SetPassword from "../pages/EspaceClient/SetPassword";
import CustomerAreaDashboard from "../pages/EspaceClient/CustomerAreaDashboard";
import CustomerAreaInvoices from "../pages/EspaceClient/CustomerAreaInvoices";
import Settings from "../pages/Settings";
import Social from "../pages/Social/Social";
import CGU from "../pages/CGU";
import PayrollSimulator from "../pages/Social/PayrollSimulator";

const RoutesApp = () => {

  return (
    <>
      <Routes>

        <Route
          path="/cgu"
          element={
            <CGU />
          }
        />
        <Route path="/error" element={<Error />} />
        <Route path="/set-password" element={<SetPassword />} />

        {/* Espace client */}
        <Route
          path="/customer-area/dashboard"
          element={
            <ProtectedRoute requiredRole="Customer">
              <CustomerAreaDashboard />
            </ProtectedRoute>
          }
        />
        
       <Route
          path="/customer-area/invoices"
          element={
            <ProtectedRoute requiredRole="Customer">
              <CustomerAreaInvoices />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer-area/social"
          element={
            <ProtectedRoute requiredRole="Customer">
              <Social />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer-area/social/payroll-simulator/:idCustomer"
          element={
            <ProtectedRoute requiredRole="Customer">
              <PayrollSimulator />
            </ProtectedRoute>
          }
        />

        {/* Espace pro */}
        <Route 
          path="/" 
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } 
        />

        <Route 
          path="/reset-password" 
          element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          } 
        />

        {/* Routes Company - rendues conditionnellement */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute requiredRole="Company">
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/crm"
          element={
            <ProtectedRoute requiredRole="Company">
              <Crm />
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <ProtectedRoute requiredRole="Company">
              <Settings />
            </ProtectedRoute>
          }
        />

        <Route
          path="/social"
          element={
            <ProtectedRoute requiredRole="Company">
              <Social />
            </ProtectedRoute>
          }
        />

        <Route
          path="/social/payroll-simulator/:idCustomer"
          element={
            <ProtectedRoute requiredRole="Company">
              <PayrollSimulator />
            </ProtectedRoute>
          }
        />

        <Route
          path="/staff"
          element={
            <ProtectedRoute requiredRole="Company">
              <Staff />
            </ProtectedRoute>
          }
        />

        <Route
          path="/time"
          element={
            <ProtectedRoute requiredRole="Company">
              <Time />
            </ProtectedRoute>
          }
        />

        <Route
          path="/invoices"
          element={
            <ProtectedRoute requiredRole="Company">
              <Invoices />
            </ProtectedRoute>
          }
        />

        <Route
          path="/payments"
          element={
            <ProtectedRoute requiredRole="Company">
              <Payment />
            </ProtectedRoute>
          }
        />

        <Route
          path="/productions"
          element={
            <ProtectedRoute requiredRole="Company">
              <Production />
            </ProtectedRoute>
          }
        />

        <Route
          path="/productions/:id"
          element={
            <ProtectedRoute requiredRole="Company">
              <ProductionDetail />
            </ProtectedRoute>
          }
        />

        {/* Route catch-all pour les routes non trouvées */}
        <Route path="*" element={<Navigate to="/error" replace />} />
      </Routes>
    </>
  );
};

export default RoutesApp;
